// Module
var code = "<div class=\"wrapper\"><div class=\"bounce1\"></div><div class=\"bounce2\"></div><div class=\"bounce3\"></div></div>";
// Exports
export default code;